<template>
  <div :class="$style.logDetail">
    <div v-if="data.logId !== 2">
      {{ getDateField(data.date) }}
    </div>
    <div v-else>
      {{ getDateField(data.date) }} / {{ data.caption }}
    </div>
    <div v-if="data.logId === 27">
      <button-audio-icon
        v-if="!isAudioPlay"
        @click="$emit('playAudio')"
      >
        <inline-svg
          :src="require('@/assets/images/icons/computer/screenshots/modal/play.svg')"
          :alt="$t('computers.playback')"
          :title="$t('computers.playback')"
          :class="$style.audioSvg"
        />
      </button-audio-icon>

      <button-audio-icon
        v-else
        @click="$emit('pauseAudio')"
      >
        <inline-svg
          :src="require('@/assets/images/icons/computer/screenshots/modal/pause.svg')"
          :alt="$t('computers.stop')"
          :title="$t('computers.stop')"
          :class="$style.audioSvg"
        />
      </button-audio-icon>
      {{ isAudioPlay ? convertTime(currentTime) : '00:00' }}/{{ convertTime(data.duration) }}
    </div>

    <div v-if="data.logId !== 2">
      <div
        v-for="fieldItem in logTypes[data.logId]"
        :key="fieldItem.field"
      >
        <button
          v-if="
            (fieldItem.field === 'file' && data.logId !== 5) ||
              (data.logId === 5 && fieldItem.field === 'file' && data.type !== $t('pages.text')) ||
              (data.logId === 23 && data.attachment)
          "
          :class="$style.saveFileButton"
          @click="saveFile()"
        >
          {{ $('pages.saveFile') }}
        </button>
        <div
          v-else-if="
            fieldItem.field !== 'file' &&
              (data.logId !== 5 || fieldItem.field !== 'text' || data.type === $t('pages.text'))
          "
          :class="$style.detailsItem"
        >
          <div :class="$style.itemHeader">
            {{ fieldItem.text }}:
          </div>
          <div :class="$style.itemContent">
            <img
              v-if="fieldItem.field === 'messenger'"
              :src="getMessengerIcon(data[fieldItem.field])"
              :class="$style.messengerIcon"
            >
            <div v-else>
              {{ data[fieldItem.field] }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="data.logId === 2">
      <img
        :class="$style.ssh"
        :src="url"
        @click="openModal()"
      >
    </div>
    <modal
      v-if="isShowModal"
      :title="data.caption"
      :fullscreen="true"
      @close="close"
    >
      <div :class="$style.content">
        <div :class="$style.imageWrapper">
          <img :src="url">
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import {
    getScreenshotLink,
    getClipboardFileLink,
    getClipboardFile,
    getMicRecordFile,
    getShadowCopyingFile,
    getMessengersAttachment,
    getPrinterDocumentLink,
    getWebcamsAndMicrophonesFile,
  } from '@/api/methods/computers';
  import Vue from 'vue';
  import VueToast from 'vue-toast-notification';
  import Modal from '@/components/common/modal/index.vue';
  import { formatDate, getTime } from '@/helpers/format-date';
  import ButtonAudioIcon from '@/components/common/button/button-audio-icon.vue';
  import { LOG_TYPES_DETAILS } from '@/assets/scripts/details';
  import { getMessengerIcon } from '@/helpers/messengers';

  Vue.use(VueToast);

  export default {
    name: 'LogDetailsAdvanced',
    components: {
      ButtonAudioIcon,
      Modal,
    },
    props: ['data', 'isRef', 'currentTime'],
    data: () => ({
      isShowModal: false,
    }),
    computed: {
      logTypes() {
        return LOG_TYPES_DETAILS;
      },
      isAudioPlay() {
        if (this.isRef) {
          return this.isRef === this.data.ref;
        }
        return false;
      },
      url() {
        if (this.data.logId === 2) {
          return getScreenshotLink(this.data.compId, this.data.path);
        }
        if (this.data.logId === 5 && this.data.type === this.$t('pages.screenshot')) {
          return getClipboardFileLink(this.data.compId, this.data.id);
        }
        return null;
      },
    },
    methods: {
      convertTime(seconds) {
        const format = (val) => `0${Math.floor(val)}`.slice(-2);
        const minutes = (seconds % 3600) / 60;
        return [minutes, seconds % 60].map(format).join(':');
      },

      getDateField(value) {
        const date = formatDate(value);
        const time = getTime(value);
        return `${date} ${time}`;
      },
      openModal() {
        this.isShowModal = true;
        this.$router.replace({
          query: {
            ...this.$route.query,
            modal: null,
          },
        });
      },
      close() {
        this.isShowModal = false;
        const query = { ...this.$route.query };
        delete query.modal;

        this.$router.replace({
          query,
        });
      },
      getMessengerIcon(name) {
        return getMessengerIcon(name);
      },
      async saveFile() {
        let result = null;
        switch (this.data.logId) {
          case 5: {
            result = await getClipboardFile(this.data.compId, this.data.id);
            break;
          }
          case 6: {
            result = await getPrinterDocumentLink(this.data.compId, this.data.id);
            break;
          }
          case 14: {
            result = await getShadowCopyingFile(this.data.compId, this.data.id);
            break;
          }
          case 23: {
            result = await getMessengersAttachment(this.data.compId, this.data.id);
            break;
          }
          case 24: {
            result = await getWebcamsAndMicrophonesFile(this.data.compId, this.data.id);
            break;
          }
          case 27: {
            result = await getMicRecordFile(this.data.compId, this.data.id);
            break;
          }
          default: {
            break;
          }
        }
        if (!result.success) {
          Vue.$toast.open({
            message: result.message,
            type: 'error',
          });
        }
      },
    },
  };
</script>

<style lang="scss" module>
  .logDetail {
    display: flex;
    flex-direction: column;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    padding: 11px;
    gap: 11px;
  }

  .detailsItem {
    display: grid;
    grid-template-columns: 40% 60%;
    min-height: 20px;
  }

  .itemHeader {
    font-weight: 500;
    min-width: 100px;
  }

  @keyframes show-overflow {
    from {
      overflow: hidden;
    }
  }
  .itemContent {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .itemContent:hover {
    white-space: unset;
    overflow: visible;
    text-overflow: inherit;
  }
  .ssh {
    cursor: pointer;
  }

  .saveFileButton {
    cursor: pointer;
    display: block;
    width: 130px;
    height: 28px;
    background: #2985bf;
    border: 2px solid #2985bf;
    border-radius: 2px;
    font: inherit;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    margin: 5px;
  }

  .content {
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .imageWrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 30px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
    }
  }
  .playSvg {
    height: 15px;
    width: 15px;
    color: #2985bf;
  }
  .audioSvg {
    height: 12px;
    width: 12px;
    color: #505253;
  }
  .messengerIcon {
    width: 20px;
    height: 20px;
  }
</style>
